import { HttpService } from 'services/http';


export const downloadTransactionStatementAPI = (queryParams) => HttpService.get('/v2/reports/transaction-statement/export', { ...queryParams, download: 'blob' });

export default { downloadTransactionStatementAPI };
